export default __webpack_public_path__ + "staff-picks.bf978335.png";